var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import LangContext from '../contexts/Language/LangContext';
var useLocalization = function () {
    return useContext(LangContext);
};
export var withLocalization = function (Component) {
    return function WrappedComponent(props) {
        // @ts-ignore
        var t = useLocalization().t;
        return React.createElement(Component, __assign({}, props, { t: t }));
    };
};
export default useLocalization;
//# sourceMappingURL=useLocalization.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import LangContext from '../contexts/Language/LangContext';
var useLocalization = function () {
    return useContext(LangContext);
};
export var withLocalization = function (Component) {
    return function WrappedComponent(props) {
        // @ts-ignore
        var t = useLocalization().t;
        return React.createElement(Component, __assign({}, props, { t: t }));
    };
};
export default useLocalization;
//# sourceMappingURL=useLocalization.js.map